import {
  IconDashboard,
  IconLayoutGrid,
  IconCalendarEvent,
  IconCalendar,
  IconUsers,
  IconCup,
  IconPhoto,
  IconInbox
} from '@tabler/icons-react';
import { NavItemType } from 'types';

const r2m: NavItemType = {
  id: 'r2m',
  title: 'R2M',
  type: 'group',
  children: [
    {
      id: 'r2m-dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/app/dashboard',
      icon: IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'r2m-event-board',
      title: 'Rendezvény tabló',
      type: 'item',
      url: '/app/event-board',
      icon: IconLayoutGrid,
      breadcrumbs: false
    },
    {
      id: 'r2m-events',
      title: 'Rendezvények',
      type: 'item',
      url: '/app/events',
      icon: IconCalendarEvent,
      breadcrumbs: false
    },
    {
      id: 'r2m-offer-requests',
      title: 'Igénybejelentések',
      type: 'item',
      url: '/app/offer-requests',
      icon: IconInbox,
      breadcrumbs: false
    },
    {
      id: 'r2m-event-rooms',
      title: 'Konferencia termek',
      type: 'item',
      url: '/app/event-rooms',
      icon: IconCalendar,
      breadcrumbs: false
    },
    {
      id: 'r2m-partners',
      title: 'Partnerek',
      type: 'item',
      url: '/app/partners',
      icon: IconUsers,
      breadcrumbs: false
    },
    {
      id: 'r2m-services',
      title: 'Szolgáltatások',
      type: 'item',
      url: '/app/services',
      icon: IconCup,
      breadcrumbs: false
    },
    {
      id: 'r2m-images',
      title: 'Képek',
      type: 'item',
      url: '/app/images',
      icon: IconPhoto,
      breadcrumbs: false
    }
  ]
};

export default r2m;
